import { findMetricValueByGrouping, getIndicatorData, metricAreZeros } from './indicatorHelperUtil';
import { IndicatorKeyEnum as keyEnum } from '../../../models/IndicatorKeyEnum';
import { CardTypesEnum } from '../../../models/CardTypesEnum';
import { isMobile } from '../../../services/booleanUtil';
import { yearsList } from './util';

/* DISBURSEMENT_PROJECTION_LAST_5_YEARS */
const addDisbursementProjectionLast5Years = (indicators, cardIndicators) => {
  const indicator = getIndicatorData(indicators, keyEnum.DISBURSEMENT_PROJECTION_LAST_5_YEARS);

  if (!indicator) {
    return null;
  } else if (metricAreZeros(indicator)) {
    const returnData = {
      id: indicator.id,
      indicatorKey: indicator.key,
      type: CardTypesEnum.MIXED_VERTICAL_BAR_LINE,
      title: 'disbursement_projection_last_5_years',
      subtitle: '',
      detailTitle: '',
      detailChartTitle: '',
      detailChartFoot: '',
      data: null,
      order: indicator.order,
    };
    cardIndicators.push(returnData);
    return returnData;
  } else {
    const labels = yearsList(indicator.metrics.filter(i => i.groupingName === 'TRANSACTION_YEAR'));
    const barsData: number[] = [];
    const lineData: number[] = [];
    const disbursementData: number[] = [];

    for (const label of labels) {
      const bar = findMetricValueByGrouping(indicator.metrics, 'TRANSACTION_YEAR', label, 'DISBURSED_AMNT_USEQ');
      const line = findMetricValueByGrouping(
        indicator.metrics,
        'TRANSACTION_YEAR',
        label,
        'ACTUAL_PROJECTION_AMNT_USEQ',
      );
      const disburment = findMetricValueByGrouping(
        indicator.metrics,
        'PROJECT_PRODUCT_TYPE',
        label,
        'CURRENT_PROJECTION_AMNT_USEQ',
      );
      barsData.push(Math.round(bar));
      lineData.push(Math.round(line));
      disbursementData.push(Math.round(disburment));
    }

    const secondBar = {
      data: lineData,
      borderColor: '#424D64',
      backgroundColor: '#5a6a8a',
      barThickness: isMobile() ? 10 : 13,
      borderWidth: 0,
      // type: 'line',
      pointRadius: 0,
      lineTension: 0,
      order: 2,
      label: 'new_orginila_projection',
    };

    const firstBar = {
      data: barsData,
      borderColor: '#424D64',
      backgroundColor: '#236bff',
      barThickness: isMobile() ? 10 : 13,
      borderWidth: 0,
      order: 1,
      label: 'DI',
    };

    const thirdBar = {
      data: disbursementData,
      backgroundColor: '#a0abc1',
      borderWidth: 0,
      barThickness: isMobile() ? 10 : 13,
      order: 3,
      label: 'new_current_projection',
    };

    const datasets = [thirdBar, secondBar, firstBar];
    const dataChart: any = {
      id: indicator.id,
      indicatorKey: indicator.key,
      type: CardTypesEnum.MIXED_VERTICAL_BAR_LINE,
      title: 'disbursement_projection_last_5_years',
      subtitle: '',
      detailTitle: 'disbursement_projection_last_5_years_detail_title',
      detailChartTitle: '',
      detailChartFoot: '',
      data: {
        labels,
        datasets,
        subLabels: [],
        cornerRadius: 2,
        gridLines: true,
      },
      order: indicator.order,
    };

    cardIndicators.push(dataChart);
    return dataChart;
  }
};

const mixedVerticalOptions = {
  legend: {
    display: false,
  },
  scales: {
    yAxes: [
      {
        gridLines: {
          display: true,
          borderDash: [4, 3],
          drawBorder: false,
        },
        ticks: {
          display: false,
        },
      },
    ],
    xAxes: [
      {
        gridLines: {
          display: false,
        },
        ticks: {
          fontColor: '#101319',
          fontFamily: 'rubik',
          fontSize: 12,
          fontStyle: 400,
        },
      },
    ],
  },
  cornerRadius: 3,
  plugins: { datalabels: { display: false } },
};

export { addDisbursementProjectionLast5Years, mixedVerticalOptions };
